module.exports = __webpack_public_path__ + "static/media/engine.58aae95b.svg";